import api from '../api'

const fetchFarmLactations = (params = {}) => {
  return api.get('/farm_lactations', { params: { farm: atob(window.localStorage.getItem('farm-id')), ...params } })
}

const fetchFarmLactationsById = (id, params = {}) => {
  return api.get(`/farm_lactations/${id}`, { params: { ...params } })
}

const createFarmLactation = (body = {}) => {
  return api.post('/farm_lactations', {
    ...body,
    farm: atob(window.localStorage.getItem('farm-id'))
  })
}

const updateFarmLactation = (id, body = {}) => {
  return api.put(`/farm_lactations/${id}`, body)
}

const deleteFarmLactation = (id) => {
  return api.delete(`/farm_lactations/${id}`)
}

export { fetchFarmLactations, fetchFarmLactationsById, createFarmLactation, updateFarmLactation, deleteFarmLactation }
